module.exports = __webpack_public_path__ + "img/fanshawe-logo.10b205a6.png";